import { createContext, useContext, useMemo, useState } from "react";
import { Client } from "react-stomp-hooks";

interface StompContextType {
  stompClient: Client | null;
  isConnected: boolean;
  setStompClient: (client: Client) => void;
}

const StompContext = createContext<StompContextType>({
  stompClient: null,
  isConnected: false,
  setStompClient: () => {},
});

export const StompProvider = ({ children }) => {
  const [stompClient, setStompClientInstance] = useState<Client | null>(null);

  // Criamos um callback para atualizar o cliente
  const setStompClient = (client: Client) => {
    setStompClientInstance(client);
  };

  // Usamos useMemo para evitar re-renderizações desnecessárias
  const contextValue = useMemo(
    () => ({
      stompClient,
      isConnected: stompClient?.connected || false,
      setStompClient,
    }),
    [stompClient, stompClient?.connected]
  );

  return (
    <StompContext.Provider value={contextValue}>
      {children}
    </StompContext.Provider>
  );
};

export const useStompContext = () => useContext(StompContext);
